import { connect } from "react-redux";
import { actionCreators } from "page/calendar/store";
import ThemesList from "./list";
import { ApplicationState } from "store";
import { getResource } from "resource/store";

const mapDispatchToProps = {
    setActiveCalendar: actionCreators.setActiveCalendar,
};

const mapStateToProps = (state: ApplicationState) => ({
    Admin_Dashboard_Themes: getResource(state, {
        key: "Admin_Dashboard_Themes",
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemesList);
